import { render, staticRenderFns } from "./ComplianceImpersonate.vue?vue&type=template&id=03bd718f&scoped=true&"
import script from "./ComplianceImpersonate.vue?vue&type=script&lang=js&"
export * from "./ComplianceImpersonate.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceImpersonate.vue?vue&type=style&index=0&id=03bd718f&prod&lang=scss&"
import style1 from "./ComplianceImpersonate.vue?vue&type=style&index=1&id=03bd718f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd718f",
  null
  
)

export default component.exports